import React, { useState, useEffect } from "react";
import ScriptVariableTable from "./ScriptVariableTable";
import { setEditorSaved } from "../../../../../../../redux/actions/integrationActions";
import { useDispatch } from "react-redux";
import uuid from "react-uuid";
import { Inline } from "@atlaskit/primitives";
import AddIcon from "@atlaskit/icon/core/add";

import { template } from "../../../../../../../common/factory/script.factory";

const ScriptVariablePanel = ({ action }) => {
  const dispatch = useDispatch();
  const [rows, setRows] = useState(0);

  useEffect(() => {}, [action]);

  const onAddVariable = () => {
    action.scriptedVariables
      ? action.scriptedVariables.push({ name: "MyVar_" + action.scriptedVariables.length, script: template, uuid: uuid(), isGlobal: false })
      : (action.scriptedVariables = [{ name: "MyVar", script: template, uuid: uuid(), isGlobal: false }]);

    dispatch(setEditorSaved(false));
    setRows(action.scriptedVariables + 1);
  };

  return (
    <>
      <Inline alignBlock="center" spread="space-between">
        <b>Scripted Variables</b>
        <div className="ihub-sidebar-action-widget-add-action" onClick={onAddVariable}>
          <AddIcon label="" />
          <div className="ihub-sidebar-action-widget-add-action-text">Add</div>
        </div>
      </Inline>
      <p className="ihub-action-tab-description">Create custom javascript variables to extract data in a more advanced way.</p>
      <p>
        The script has access to the current scope and <b>must</b> must return a value. Read more
        <a href="https://rixter.atlassian.net/l/cp/xPdWath7"> here</a>.
      </p>
      <ScriptVariableTable action={action} updated={rows} />
    </>
  );
};

export default ScriptVariablePanel;
